import {Component, Input, OnChanges, OnInit, SimpleChanges} from "@angular/core";
import {UntypedFormBuilder, Validators} from "@angular/forms";
import {Country} from "../../country/country.model";
import {FormComponent} from "../form.component";
import {CountryService} from "../../country/country.service";
import {I18NextService} from "angular-i18next";
import {Customer} from "../../customer/customer.model";
import {streetNumberSpacingValidator} from "../../myshared/streetValidator";

type Form = {
  name: string;
  street: string;
  street2: string;
  zip: string;
  city: string;
  country: string;
  email?: string;
  electronic_invoice_email?: string;
  vat?: string;
}

@Component({
    selector: 'app-customer-form',
    templateUrl: './customer-form.component.html',
    styleUrls: [],
    standalone: false
})
export class CustomerFormComponent extends FormComponent<Customer> {

  @Input() customer?: Customer;
  @Input() countries: Country[];
  @Input() isCountryChangeable: boolean = true;
  @Input() submitButtonLabel = 'app_update';
  @Input() showInvoiceMail: boolean = true;
  @Input() showElectronicInvoiceMail: boolean = true;

  private isCountryTraced: boolean = false;

  constructor(protected fb: UntypedFormBuilder, protected i18next: I18NextService, private countryService: CountryService) {
    super(fb, i18next);
  }

  public formMapper(form: Form): Customer {
    return new Customer(
      this.customer?.id ?? '',
      form.name,
      form.street,
      form.street2,
      form.zip,
      form.city,
      (!this.isCountryChangeable
        ? this.customer.country
        : this.countries.find(country => country.code === form.country)),
      [],
      form.email,
      form.electronic_invoice_email,
    );
  }

  protected createForm() {
    this.form = this.fb.group({
      name: [this.customer?.name ?? '', Validators.required],
      street: [this.customer?.street ?? '', [Validators.required, streetNumberSpacingValidator]],
      street2: [this.customer?.street2 ?? ''],
      zip: [this.customer?.zip ?? '', Validators.required],
      city: [this.customer?.city ?? '', Validators.required],
      country: [{ value: this.customer?.country?.code ?? 'DE', disabled: !this.isCountryChangeable}, Validators.required],
      email: this.showInvoiceMail ? [this.customer?.email ?? '', [Validators.email, ...(this.customer?.email ? [Validators.required] : []) ]] : undefined,
      electronic_invoice_email: this.showElectronicInvoiceMail ? [this.customer?.electronic_invoice_email ?? '', Validators.email] : undefined,
    })

    // If we do not have a country, try to check where the customer lives
    if (!this.isCountryTraced && this.countries.length > 0 && !this.customer?.country.code && this.isCountryChangeable) {
      this.countryService.traceCountry().subscribe((code: any) => {
        const country = this.countries.find((c: Country) => c.code.toUpperCase() === code.toUpperCase());
        this.form.get('country').setValue(country?.code ?? 'DE');
        this.isCountryTraced = true;
      });
    }
  }
}
